import type {
  ICompanyObjective,
  IPerformanceObjective,
  IPerformanceSettings,
  IPerformanceTeam,
  IPerformanceTeamListMember,
  IPerformanceTeamMember,
} from '@/types/Data'
import type {
  IGetCompanyObjectivesList,
  IGetTeamMember,
  IPayloadCompanyObjective,
  IPayloadTeam,
  IPerformanceList,
  IUpdatePerformanceSettings,
  IUpdateTeamMember,
} from '@/types/Request'
import BaseService from '../BaseService'

export default class PerformanceServices extends BaseService {
  // #region Settings
  GetPerformanceSettings() {
    return this.GET<IPerformanceSettings>(this.PATHS.GET_PERFORMANCE_MANAGEMENT_SETTINGS)
  }
  UpdatePerformanceSettings(data: IUpdatePerformanceSettings) {
    return this.POST<void>(this.PATHS.UPDATE_PERFORMANCE_MANAGEMENT_SETTINGS, data)
  }
  // #endregion

  // #region Company Objectives
  CreateCompanyObjective(data: IPayloadCompanyObjective) {
    return this.POST<ICompanyObjective>(this.PATHS.CREATE_COMPANY_OBJECTIVE, data)
  }
  UpdateCompanyObjective(data: IPayloadCompanyObjective) {
    return this.PUT<ICompanyObjective>(this.PATHS.UPDATE_COMPANY_OBJECTIVE, data)
  }
  GetCompanyObjectives(data: IGetCompanyObjectivesList) {
    return this.GET<ICompanyObjective[]>(this.PATHS.GET_COMPANY_OBJECTIVES_LIST, data)
  }
  DeleteCompanyObjective(id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_COMPANY_OBJECTIVE, { id })
  }
  // #endregion

  // #region Teams
  CreateTeam(data: IPayloadTeam) {
    return this.POST<IPerformanceTeam>(this.PATHS.CREATE_TEAM, data)
  }
  UpdateTeam(data: IPayloadTeam) {
    return this.PUT<IPerformanceTeam>(this.PATHS.UPDATE_TEAM, data)
  }
  GetTeamList() {
    return this.GET<IPerformanceTeam[]>(this.PATHS.GET_TEAM_LIST)
  }
  DeleteTeam(id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_TEAM, { id })
  }
  // #endregion

  // #region Objectives
  GetObjectiveList(data?: IPerformanceList) {
    return this.GET<IPerformanceObjective[]>(this.PATHS.GET_OBJECTIVE_LIST, data)
  }
  // #endregion

  // #region Teams
  UpdateTeamMembers(data: IUpdateTeamMember) {
    return this.POST<IPerformanceTeamMember>(this.PATHS.UPDATE_TEAM_MEMBERS, data)
  }
  GetTeamMembers(data: IGetTeamMember) {
    return this.GET<IPerformanceTeamListMember[]>(this.PATHS.GET_TEAM_MEMBERS, data)
  }
  // #endregion
}
